import { makeStyles } from "@material-ui/core";
import { useChannelContext } from "@sendbird/uikit-react/Channel/context";
import React from "react";
import { useState } from "react";
import { ReactComponent as PatientProfileImg } from "../../img/patientProfile.svg";
import createPersistedState from "use-persisted-state";

import sendbirdSelectors from "@sendbird/uikit-react/sendbirdSelectors";
import useSendbirdStateContext from "@sendbird/uikit-react/useSendbirdStateContext";
import { useTranslation } from "react-i18next";

const useTokenState = createPersistedState("token");
const useProfileState = createPersistedState("profile");

const useStyles = makeStyles((theme) => ({
  messageListParent: { height: "calc(100vh - 262px)", overflow: "auto" },
  messageInputParent: { height: "165px" },
  messageInput: {
    width: "100%",
    height: "100%",
    resize: "none",
    border: "1px solid #00000033",
    borderRadius: "4px",
    padding: "10px",
  },
  messageInputContainer: {
    width: "100%",
    height: "180px",
  },
  sendMessageContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "calc(100% - 72px)",
  },
  userProfileIconParent: {
    height: "20px",
    width: "20px",
    marginTop: "10px",
    marginRight: "10px",
  },
  messageInputBottom: {
    position: "fixed",

    bottom: "0px",
    width: "100%",
    display: "flex",
  },
  btn_block: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
}));

const sendMessagee = (message, channelState, setUserInputState) => {
  if (message.trim().length > 0 && channelState != undefined) {
    console.log(message);
    channelState.sendMessage({ message: message });
    setUserInputState("");
  }
};

const sendMessage = async (
  message,
  channelState,
  setUserInputState,
  initChat,
  isAdmin,
  isChatActivatedState,
  dispatchIsChatActivated,
  token,
  senderId
) => {
  if (message.trim().length > 0) {
    if (isChatActivatedState.data && channelState) {
      // If channelState is available, send the message
      channelState?.sendMessage({ message: message });
      setUserInputState("");
    } else {
      // If channelState is not available, call initChat first
      const initChatResponse = await initChat(isAdmin);
      if (initChatResponse?.status?.success) {
        dispatchIsChatActivated({ type: "LOADED", payload: { init: true } });
        const channelId = initChatResponse.data.channels[0].channel_url;
        const sendMessageResponse = await sendMessageThroughAPI(
          channelId,
          senderId,
          message,
          token
        );

        sendMessageResponse?.data?.status?.success == true &&
          setUserInputState("");
      } else {
        // Handle initChat failure, e.g., show an error message
        console.error("initChat failed");
      }
    }
  }
};

const sendMessageThroughAPI = async (channelId, senderId, message, token) => {
  const URL = `/api/v1/chat/channel/${channelId}/messages`;
  const body = {
    senderId: senderId,
    message: message,
    msgType: "MESG",
  };
  try {
    const response = await fetch(URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify(body),
    });
    const data = await response.json();

    return data;
  } catch (e) {
    return null;
  }
};

const MessageInput = ({
  initChat,
  isChatActivatedState,
  dispatchIsChatActivated,
  isFileShareEnabled,
  isAdmin,
}) => {
  const classes = useStyles();
  const [userInputMessageState, setUserInputState] = useState("");

  const { t } = useTranslation();

  const [token, _] = useTokenState();
  const [profile, setProfile] = useProfileState();

  const channelState = useChannelContext?.();

  const globalStore = useSendbirdStateContext();

  const sendFileMessage = sendbirdSelectors.getSendFileMessage(globalStore);

  console.log("channel", channelState);
  console.log("sendFile", sendFileMessage);

  //   const { sendMessage } = channelState;
  //   const useSendMessage = sendMessage();

  return (
    <div className={classes.messageInputBottom}>
      <div className={classes.userProfileIconParent}>
        <PatientProfileImg />
      </div>
      <div className={classes.sendMessageContainer}>
        <div className={classes.messageInputContainer}>
          <textarea
            ref={channelState?.messageInputRef}
            value={userInputMessageState}
            onChange={(event) => setUserInputState(event.target.value)}
            className={classes.messageInput}
            placeholder={
              isAdmin
                ? t("CHAT.ReceptionistInputText")
                : t("CHAT.DoctorInputText")
            }
          ></textarea>
        </div>
        <div className="btn_block" style={{ position: "relative" }}>
          <button
            onClick={() => {
              sendMessage(
                userInputMessageState,
                channelState,
                setUserInputState,
                initChat,
                isAdmin,
                isChatActivatedState,
                dispatchIsChatActivated,
                token,
                profile.patientId
              );
            }}
            className="btn btn_primary py-2 px-4 my-2"
          >
            Send
          </button>
        </div>
        {!isAdmin &&
          (isFileShareEnabled ? (
            <div
              style={{
                position: "absolute",
                bottom: "10px",
                right: "38px",
                fontSize: "23px",
              }}
            >
              <label
                className="custom-file-upload"
                style={{ height: "30px", width: "30px", cursor: "pointer" }}
              >
                <i className="fa fa-paperclip" aria-hidden="true">
                  <input
                    type="file"
                    id="custom-input"
                    style={{ display: "none" }}
                    onChange={() => {
                      const file =
                        document.querySelector("#custom-input").files[0];
                      channelState.sendFileMessage(file);
                    }}
                  />
                </i>
              </label>
            </div>
          ) : (
            <div
              style={{
                position: "absolute",
                bottom: "10px",
                right: "38px",
                fontSize: "23px",
              }}
            >
              <label
                className="custom-file-upload"
                style={{ height: "30px", width: "30px", color: "#00000033" }}
              >
                <i className="fa fa-paperclip" aria-hidden="true"></i>
              </label>
            </div>
          ))}
      </div>
    </div>
  );
};

export default MessageInput;
